import React, { Fragment } from "react";
import Skeleton from "react-loading-skeleton-2";

import Td from "./Td";

const Loading = ({ count }) => (
  <Fragment>
    {Array.from({ length: 5 }, (_, i) => (
      <tr key={i}>
        {Array.from({ length: count }, (_, i) => (
          <Td key={i}>
            <Skeleton />
          </Td>
        ))}
      </tr>
    ))}
  </Fragment>
);

export default Loading;
